import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  inputIcons: {
    marginTop: -2,
    marginRight: 12,
  },
  endInputIcon: {
    cursor: 'pointer',
  },
  formLabel: {
    marginTop: 10,
    color: 'black',
    fontSize: '0.8125rem',
  },
  errorText: {
    fontSize: '0.7rem',
  },
}));

export default useStyles;
